import { render } from "./HorseCoveringCertificatesHistoryTab.vue?vue&type=template&id=7e142944"
import script from "./HorseCoveringCertificatesHistoryTab.vue?vue&type=script&lang=js"
export * from "./HorseCoveringCertificatesHistoryTab.vue?vue&type=script&lang=js"

import "./HorseCoveringCertificatesHistoryTab.vue?vue&type=style&index=0&id=7e142944&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__